import { FormEvent, useState } from "react"
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom"
import { verifySmsCode } from "@/api/auth"
import { getSavedPersonalDataConsentPayload } from "@/lib/personalDataConsent"
import { useAuth } from "@/context/AuthContext"
import {
  authErrorMessage,
  formatBelarusPhoneDisplay,
} from "@/lib/phone"

export default function VerifySmsPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { login } = useAuth()
  const phone = (location.state as { phone?: string } | null)?.phone
  const [code, setCode] = useState("")
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  if (!phone) {
    return <Navigate to="/login" replace />
  }

  const phoneNumber = phone

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    if (!code.trim()) {
      setError("Введите код из SMS")
      return
    }
    setLoading(true)
    try {
      const personalDataConsent = getSavedPersonalDataConsentPayload()
      const data = await verifySmsCode(
        phoneNumber,
        code.trim(),
        personalDataConsent
      )
      const nested =
        data.token && typeof data.token === "object" && !Array.isArray(data.token)
          ? (data.token as { token?: string })
          : null
      const token =
        typeof data.token === "string"
          ? data.token
          : typeof nested?.token === "string"
            ? nested.token
            : typeof (data as { accessToken?: string }).accessToken === "string"
              ? (data as { accessToken: string }).accessToken
              : null
      if (!token) {
        setError("Сервер не вернул токен. Проверьте ответ API.")
        return
      }
      await login(token)
      navigate("/play", { replace: true })
    } catch (err: unknown) {
      setError(
        authErrorMessage(err, "Неверный код или ошибка входа")
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="mx-auto flex min-h-dvh max-w-md flex-col justify-center px-5 py-10">
      <Link to="/login" className="text-sm text-guardians-accent">
        ← Назад
      </Link>
      <h1 className="mt-4 text-xl font-semibold">Код из SMS</h1>
      <p className="mt-1 text-sm text-guardians-muted">
        {formatBelarusPhoneDisplay(phone)}
      </p>

      <form className="mt-8 space-y-4" onSubmit={onSubmit}>
        <label className="block text-sm text-guardians-muted">
          Код
          <input
            inputMode="numeric"
            autoComplete="one-time-code"
            className="mt-1 w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-center text-base tracking-widest text-white outline-none focus:border-guardians-accent sm:text-lg"
            value={code}
            onChange={(ev) => setCode(ev.target.value)}
          />
        </label>

        {error ? <p className="text-sm text-red-400">{error}</p> : null}

        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-xl bg-guardians-accent py-3 font-medium text-guardians-bg disabled:opacity-60"
        >
          {loading ? "Вход…" : "Войти"}
        </button>
      </form>
    </div>
  )
}
